import React from 'react'
import PageHeader2 from '../../../componentsII/PageHeader2'

const UNFCCCReport = () => {
  return (
    <div>
      <PageHeader2
        title="UNFCCC Report ( United Nations Framework Convention on Climate Change )"
        text={[
          "",
        ]}
        handleClick={() => {}}
      >
      </PageHeader2>
    </div>
  )
}

export default UNFCCCReport
